goog.provide('yext.m4.routes');

goog.require('yext');

goog.scope(function() {
  yext.m4.routes = {
    pullResource: route('/s/:businessId/configeditor/resource/:resourceType'),
    save: route('/s/:businessId/configeditor/resource'),
    fetchJSONSchemaConfigurations: route('/:editorSettingsUriPrefix/schema/configurations/:resourceType'),
    generateAutocompleteSnippets: route('/configeditor/schema/autocomplete/generate'),
  };

  /**
   * Helper method for routes, copied from js/yext/developerapps/routes.js.
   *
   * @param {string} path within apps with placeholders
   * @return {function(?Object): string} to be called with key/values
   */
  function route(path) {
    return function(obj) {
      var pattern = path;
      obj = obj || {};
      var queryParams = [];
      for (var key in obj) {
        var vals = obj[key];
        if (!Array.isArray(obj[key])) {
          vals = [obj[key]];
        }
        for (var i = 0; i < vals.length; i++) {
          if (vals[i] === null || vals[i] === undefined) {
            continue;
          }
          var val = encodeURIComponent(vals[i]);
          var pattern2 = pattern.replace(':'+key, val);
          if (pattern === pattern2) {
            queryParams.push(key + '=' + val);
          }
          pattern = pattern2;
        }
      }
      if (queryParams.length > 0) {
        pattern += '?' + queryParams.join('&');
      }
      return pattern;
    };
  }
});
